import styled, { css } from 'styled-components';

export const Heading = styled.h1<{ as?: React.ElementType }>`
  font-family: ${Styles.fontFamily.base};
  line-height: 1.75;
  text-align: center;
  text-transform: ${Styles.textTransform.headlines};
  ${({ as }) =>
    as === 'h2' &&
    css`
      font-size: 2.25rem;
      ${Styles.desktop} {
        font-size: 3rem;
      }
    `}
`;
